import React, { FC, useEffect, useState } from 'react'
import { HStack } from '@/XelaReact'
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react'
import { router, usePage } from '@inertiajs/react'
import { showNotification } from '@mantine/notifications'
import Notifications from '@/Components/Notifications/Notifications'
import HubSidebar from '@/Components/Hub/HubSidebar'
import AddQuickHubLeadModal from '@/Layouts/Hub/Modals/AddQuickHubLeadModal'
import UploadBulkDocumentsModal from '@/Layouts/Modals/UploadBulkDocumentsModal'
import DocumentViewerModal from '@/Layouts/Modals/DocumentViewerModal'
import GlobalSearchModal from '@/Layouts/Modals/GlobalSearchModal'
import { LoadingOverlay } from '@mantine/core'
import AddQuickHubVisitorLeadModal from '@/Layouts/Hub/Modals/AddQuickHubVisitorLeadModal'

const HubAuthenticated: FC<{ children: React.ReactNode }> = ({ children }) => {
  const flash = usePage().props.flash as Record<string, unknown>
  const [loadingIndicator, setLoadingIndicator] = useState<boolean>(false)

  useEffect(() => {
    if (flash.message) {
      showNotification({
        withCloseButton: true,
        autoClose: 5000,
        title: 'Success',
        message: flash.message as string,
        color: 'green',
        icon: <IconCheck />,
      })
    }

    if (flash.error) {
      showNotification({
        withCloseButton: true,
        autoClose: 5000,
        title: 'Error',
        message: flash.error as string,
        color: 'red',
        icon: <IconAlertTriangle />,
      })
    }
  }, [flash.timestamp, flash.message, flash.error])

  useEffect(() => {
    return router.on('start', (event) => {
      if (event.detail.visit.method === 'get') {
        setLoadingIndicator(true)
      }
    })
  }, [])

  useEffect(() => {
    return router.on('finish', () => {
      setLoadingIndicator(false)
    })
  }, [])

  return (
    <>
      <LoadingOverlay visible={loadingIndicator} color={'blueX'} />
      <div className="w-full" style={{ position: 'relative', height: '100vh' }}>
        <div style={{ position: 'absolute', right: 24, top: 14, zIndex: 100 }}>
          <Notifications portal={'Hub'} />
        </div>
        <HStack alignItems="flex-start" style={{ alignItems: 'stretch' }}>
          <HubSidebar />
          {children}
        </HStack>
        <GlobalSearchModal portal={'Hub'} />
        <AddQuickHubLeadModal />
        <AddQuickHubVisitorLeadModal />
        <UploadBulkDocumentsModal portal={'Hub'} />
        <DocumentViewerModal />
      </div>
    </>
  )
}

export default HubAuthenticated
